import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class BelongingType extends Enum {
  static BOOKS = {
    key: 'books',
    get value() {
      return Lang.t('asset.books');
    }
  };

  static CLOTHING = {
    key: 'clothing',
    get value() {
      return Lang.t('asset.clothing');
    }
  };

  static ELECTRONICS = {
    key: 'electronics',
    get value() {
      return Lang.t('asset.electronics');
    }
  };

  static FURNITURE = {
    key: 'furniture',
    get value() {
      return Lang.t('asset.furniture');
    }
  };

  static HOUSEHOLD_GOODS = {
    key: 'household_goods',
    get value() {
      return Lang.t('asset.household-goods');
    }
  };

  static MOVIES_DVDS = {
    key: 'movies_dvds',
    get value() {
      return Lang.t('asset.movies-dvds-and');
    }
  };

  static MUSIC = {
    key: 'music',
    get value() {
      return Lang.t('asset.music');
    }
  };

  static SPORTING_GOODS = {
    key: 'sporting_goods',
    get value() {
      return Lang.t('asset.sporting-goods');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };
}
